// @flow
import { sum, get, size, map, omit, concat } from "lodash";
import type { Changes } from "@tvg/types/Race";

const countRaceChanges = (raceChanges: Changes) =>
  sum(
    concat(
      ...map(Object.keys(omit(raceChanges, "__typename")), (cType: string) =>
        map(
          Object.keys(omit(get(raceChanges, cType, {}), "__typename")),
          (cSubType: string) => size(get(raceChanges, `${cType}.${cSubType}`))
        )
      )
    )
  );

export default countRaceChanges;
